// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Assets Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Assets Worker')

  // $FlowFixMe
  const AssetWorker = require('worker-loader?name=[hash].assets.wrkr.js!./worker.js')
  worker = new AssetWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
